<template>
  <span>
    <BaseMap
      @map="initMap"
      :mapTheme="'default'"
      :map-id="'main_map'"
      :authUserInfo="authUserInfo"
      :showHYBRID_MAP="showHYBRID_MAP"
    ></BaseMap>
    <setTool
      v-show="page_config.showSet"
      :gfLevelList.sync="gfLevelList"
    ></setTool>
    <menuBar></menuBar>
    <!-- <statistics :dataTime="data_time" :timeType="time_type"></statistics> -->
    <color-bar
      :colorType="colorType"
      :drawValue="sensortype"
      v-show="!showGfStation"
    ></color-bar>
    <color-bar
      :colorType="colorType"
      :drawValue="gfSensortype[0]"
      canvasId="myCanvas0"
      v-show="showGfStation && gfSensortype.length < 2"
    ></color-bar>
    <div v-show="showGfStation && gfSensortype.length == 2">
      <color-bar
        :colorType="colorType"
        drawValue="cod"
        canvasId="myCanvas1"
        bottom="75px"
        showTitle
      ></color-bar>
      <color-bar
        :colorType="colorType"
        drawValue="cod_mn"
        canvasId="myCanvas2"
        showTitle
      ></color-bar>
    </div>
    <!-- <markerLegend></markerLegend> -->
  </span>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import BaseMap from "@/components/map/BaseMap";
import { DrawCar, getSize } from "@/utils/layers/car_layer";
import ColorBar from "@/components/map/ColorBar";
// import markerLegend from "@/components/map/markerLegend";
import { addMarker, getWindDirectionDesc, addTextMarker } from "@/utils/utils";

import { openPoints } from "@/utils/openPointWindowInfo";
import { lineLayer } from "@/utils/layers/line_layers";

import {
  getRoadColor,
  getInfoComposite,
  getStationSampleDevice
} from "@/api/api";
import routeLayer from "@/utils/layers/route_layer";
import setTool from "@/components/map/setTool";
import menuBar from "@/components/menuBar";
// import statistics from "@/components/statistics";
import {
  openStationWindow,
  getInstance,
  showGfStationInfo
} from "@/utils/open_station_window";
import { text_options_high, text_options_name } from "@/options/mapv_options";
import { zoomCircleSize, gredient_default_color } from "@/utils/common.js";
import { group_map_tile } from "@/options/option";
// import { ComplexCustomOverlay } from "@/utils/point_info.js";
import "@/utils/flashMarker";

var mqtt = require("mqtt");
let mqttclient;
let DATA_TOPIC = "v2/from_dev/pkt_calied_1s";

function avg_li(li) {
  var sum = 0;
  var count = 0;
  for (let i of li) {
    sum += i;
    count++;
  }
  return Math.round(sum / count);
}

export default {
  name: "MapView",
  data() {
    return {
      map: null,
      isSetViewport: true,
      showCarVideo: false,
      routeLayerObj: null,
      groundOverlay: null,
      wzPointLayer: null,
      stationDialogVisible: false,
      colorType: "static",
      station_dialog_type: "station",
      chooseStation: {},

      mapvLayer: "",
      textMapLayer: "",
      textMapLayerName: "",
      iconMapLayer: "",
      gfStationMapLayer: "",

      dataSet: [],
      alarmDataSet: [],
      gfStantionDataSet: [],
      cirSize: 5,
      markers: [],
      markersVirtual: [],
      groundOverlayList: [],
      gfLevelList: []
    };
  },
  components: {
    BaseMap,
    ColorBar,
    // markerLegend,
    setTool,
    menuBar
    // statistics
  },
  mounted() {
    this.$store.dispatch("getStationData");
    this.$store.dispatch("getStationSampleDeviceStatus");
  },
  computed: {
    ...mapState([
      "authUserInfo",
      "sensortype",
      "colorRange",
      "showMapTile",
      "stationData",
      "timeRange",
      "time_type",
      "data_time",
      "stations",
      "virtualStations",
      "virtualStationData",
      "page_config",
      "showHYBRID_MAP",
      "mapInfo",
      "locateAlarm",
      "mapMode",
      "sampleDevices",
      "gfStationData",
      "showGfStation",
      "gfSensortype"
    ]),
    intensity() {
      return new colorIntensity.getIntensity({
        dataType: this.sensortype,
        max: this.colorRange[1],
        min: this.colorRange[0],
        colorType: "static"
      });
    }
  },
  watch: {
    time_type() {
      this.map.closeInfoWindow();
      this.subcursn();
      this.alarmMapLayer && this.alarmMapLayer.hide();
    },
    showMapTile() {
      if (this.showMapTile) {
        this.addImageLayer();
      } else {
        for (let i of this.groundOverlayList) {
          this.map.removeOverlay(i);
        }
      }
    },
    stationData() {
      if (this.stationData.length && this.isSetViewport) {
        this.setViewport();
        this.isSetViewport = false;
      }
      this.drawWzpoint();
      // this.drawInfo(this.stationData)
      this.time_type === "real" && this.subcursn();
      if (this.mapMode === "alarm") {
        this.toLocateAlarmStation();
      }
    },
    sampleDevices() {
      this.drawWzpoint();
    },
    intensity() {
      this.drawWzpoint();
    },
    sensortype() {
      this.map.closeInfoWindow();
      this.drawWzpoint();
    },
    gfSensortype() {
      this.map.closeInfoWindow();
      this.drawWzpoint();
    },
    mapInfo() {
      if (this.mapInfo) {
        this.openMapWindowStation(this.map, this.mapInfo);
        this.$store.commit("openMapWindow", null);
      }
    },
    intensity() {
      this.changeMapColor();
    },
    locateAlarm() {
      // 获取报警时间数据
      if (this.mapMode == "alarm") {
      } else {
        this.$store.dispatch("getStationData");
        this.iconMapLayer && this.iconMapLayer.hide();
      }
    },
    showGfStation() {
      this.drawWzpoint();
    },
    gfLevelList() {
      this.drawWzpoint();
    }
  },
  methods: {
    subcursn() {
      if (mqttclient) {
        mqttclient.end();
      }

      mqttclient = mqtt.connect(`ws://yulin.novaecs.com:3001/ws`, {
        username: "novadbuser",
        password: "123654"
      });

      mqttclient.on("connect", function() {
        let topics = [];
        mqttclient.subscribe(DATA_TOPIC);
      });

      mqttclient.on("message", (topic, message) => {
        if (this.time_type != "real" || this.mapMode == "alarm") {
          mqttclient.end();
          return;
        }
        let objs = JSON.parse(message.toString());

        // 实时微站数据
        this.getRealStationData(objs);
      });
    },
    getRealStationData(objs) {
      let stationData = this.$_.cloneDeep(this.stationData);
      stationData = stationData.map((item, i) => {
        for (let i in objs) {
          const sn = objs[i].sn;
          if (item.sn == sn) {
            item.pm25 = objs[i].pm25 ? objs[i].pm25 : item.pm25;
            item.pm10 = objs[i].pm10 ? objs[i].pm10 : item.pm10;
            item.wendu = objs[i].wendu ? objs[i].wendu : item.wendu;
            item.shidu = objs[i].shidu ? objs[i].shidu : item.shidu;
            item.wind_direction = objs[i].wind_direction
              ? objs[i].wind_direction
              : item.wind_direction;
            item.wind_speed = objs[i].wind_speed
              ? objs[i].wind_speed
              : item.wind_speed;
          }
        }
        return item;
      });
      this.$store.commit("setStationData", stationData);
      // 实时虚拟设备数据
      this.getRealVirtualData(stationData);
    },
    getRealVirtualData(stationData) {
      let virData = this.$_.cloneDeep(this.virtualStationData);
      let curVirData = [];
      for (let i of virData) {
        let child = i.child_stations;
        let child_list = child.split(",");
        let child_station_data = stationData.filter(x => {
          return child_list.indexOf(x.station_id + "") !== -1;
        });
        let virtual_pm10_list = child_station_data
          .map(x => x.pm10)
          .filter(x => x !== -1);
        let virtual_pm25_list = child_station_data
          .map(x => x.pm25)
          .filter(x => x !== -1);
        let virtual_wendu_list = child_station_data
          .map(x => x.wendu)
          .filter(x => x !== -1);
        let virtual_shidu_list = child_station_data
          .map(x => x.shidu)
          .filter(x => x !== -1);
        let virtual_wind_speed_list = child_station_data
          .map(x => x.wind_speed)
          .filter(x => x !== -1);
        let virtual_pm10 = avg_li(virtual_pm10_list);
        let virtual_pm25 = avg_li(virtual_pm25_list);
        let virtual_wendu = avg_li(virtual_wendu_list);
        let virtual_shidu = avg_li(virtual_shidu_list);
        let virtual_wind_speed = avg_li(virtual_wind_speed_list);
        var rate = 0.3;
        i.pm10 = virtual_pm10 * rate;
        i.pm25 = virtual_pm25 * rate;
        i.wendu = virtual_wendu * rate;
        i.shidu = virtual_shidu * rate;
        i.wind_speed = virtual_wind_speed * rate;
        curVirData.push(i);
      }
      this.$store.commit("setVirtualStationData", curVirData);
    },
    toLocateAlarmStation() {
      for (let item of this.stationData) {
        if (item.sn === this.locateAlarm.sn) {
          this.currentAlarm = {
            ...item,
            ...this.locateAlarm
          };
        }
      }
      this.setAlarmCenter();
    },
    setAlarmCenter() {
      this.alarmMapLayer && this.alarmMapLayer.hide();
      const { Lng, Lat } = this.currentAlarm;
      const point = new BMap.Point(Lng, Lat);
      this.map.centerAndZoom(point, 18);

      let img = new Image();
      img.src = "images/border.png";
      img.onload = () => {
        this.alarmDataSet.set([
          {
            geometry: {
              type: "Point",
              coordinates: [Lng, Lat]
            },
            icon: img
          }
        ]);
      };
    },
    initMap(map) {
      console.log("init map");
      this.map = map;
      this.addImageLayer();
      this.drawFlash(map);
      this.$emit("initMap", map);
      map.addEventListener("zoomend", this.changeCirSize);
      let options = {
        size: this.cirSize,
        zIndex: 2,
        methods: {
          click: item => {
            // 点击事件，返回对应点击元素的对象值
            this.clickMapv(item);
          }
        }
      };
      this.dataSet = new mapv.DataSet([]); // 散点图层
      this.alarmDataSet = new mapv.DataSet([]);
      this.gfStantionDataSet = new mapv.DataSet([]);

      this.mapvLayer = new mapv.baiduMapLayer(map, this.dataSet, options);
      this.textMapLayer = new mapv.baiduMapLayer(
        map,
        this.dataSet,
        text_options_high
      );
      this.textMapLayerName = new mapv.baiduMapLayer(
        map,
        this.dataSet,
        text_options_name
      );

      if (this.page_config.showWind) {
        this.windMapLayer = new mapv.baiduMapLayer(map, this.dataSet, {
          draw: "icon",
          width: 50,
          height: 50
        });
      }

      this.iconMapLayer = new mapv.baiduMapLayer(map, this.alarmDataSet, {
        draw: "icon",
        width: 50,
        height: 50
      });

      let option = {
        // draw: "icon",
        size: this.cirSize,
        zIndex: 3,
        methods: {
          click: item => {
            // 点击事件，返回对应点击元素的对象值
            if (!item) return;
            showGfStationInfo(this.map, item);
          }
        }
      };
      this.gfStationMapLayer = new mapv.baiduMapLayer(
        map,
        this.gfStantionDataSet,
        option
      );

      this.gfStationTextMapLayer = new mapv.baiduMapLayer(
        map,
        this.gfStantionDataSet,
        text_options_high
      );
      this.gfStationTextMapLayerName = new mapv.baiduMapLayer(
        map,
        this.gfStantionDataSet,
        text_options_name
      );
      // this.drawTimeAnimate();
    },
    setViewport() {
      console.log("setViewport");
      let points = [];
      for (let i of this.stationData) {
        if (i.Lng && i.Lat) {
          let p = new BMap.Point(i.Lng, i.Lat);
          points.push(p);
        }
      }
      if (points.length === 0) {
        if (this.page_config.mapSetting) {
          this.map.centerAndZoom(
            this.page_config.mapSetting.center,
            this.page_config.mapSetting.zoom
          );
        } else {
          let zoom = this.map.getZoom();
          this.map.centerAndZoom(this.authUserInfo.city, zoom);
        }
      } else {
        this.map.setViewport(points);
      }
    },
    changeCirSize() {
      let zoom = this.map.getZoom();
      this.cirSize = zoomCircleSize[zoom];
      this.mapvLayer.update({
        options: {
          size: this.cirSize
        }
      });
      this.gfStationMapLayer.update({
        options: {
          size: this.cirSize
        }
      });
      this.drawWzpoint();
      if (zoom < 17) {
        this.alarmMapLayer && this.alarmMapLayer.hide();
      } else {
        this.alarmMapLayer && this.alarmMapLayer.show();
      }
    },
    changeMapColor() {
      console.log("changeMapColor");
      let sensortypeInfo = G_SENSOR_DATA_TYPE_INFO.find(
        x => x.value === this.sensortype
      );
      let option;
      if (sensortypeInfo.default_bar_type === "gradient") {
        let rate_data = colorIntensity.getColorRate(this.sensortype, "static");
        option = {
          max: this.colorRange[1],
          min: this.colorRange[0],
          draw: "intensity",
          gradient: rate_data
        };
      } else {
        let splitList = colorIntensity.getColorSplitList(
          this.sensortype,
          "static"
        );
        option = {
          draw: "choropleth",
          // 按数值区间来展示不同颜色的点
          splitList: splitList
        };
      }
      this.mapvLayer.update({ options: option });
      this.gfStationMapLayer.update({ options: option });
      text_options_high.intensityCustom = this.intensity;
      this.textMapLayer.update(text_options_high);
    },
    clickMapv(v) {
      if (!v) return;
      // let station = v.station;
      // let info = v.info;
      // station.station_id = station.ID;
      // station.data = { time: info.TIME };
      this.openMapWindowStation(this.map, v.station);
    },
    changeVisible(v) {
      this.stationDialogVisible = v;
    },
    setImg(img_src, sw, ne) {
      let img_url = `tile/${img_src}`;
      let img = new Image();
      img.src = img_url;
      var groundOverlayOptions = {
        opacity: 0.8,
        displayOnMinLevel: 0,
        displayOnMaxLevel: 30,
        zIndex: 1
      };
      // 初始化GroundOverlay
      var groundOverlay = new BMap.GroundOverlay(
        new BMap.Bounds(sw, ne),
        groundOverlayOptions
      );
      // groundOverlay.setZIndex(1);
      // 设置GroundOverlay的图片地址

      groundOverlay.setImageURL(img_url);
      // groundOverlayList.push(groundOverlay);
      this.groundOverlay = groundOverlay;
      this.map.addOverlay(groundOverlay);
      img.onload = () => {
        setTimeout(() => {
          this.setTileZindex(img_url);
        }, 100);
      };
      return groundOverlay;
    },
    addImageLayer() {
      let groundOverlayList = [];
      if (this.showMapTile) {
        if (this.page_config.tileImg) {
          var overlay = this.setImg(
            this.page_config.tileImg.name,
            this.page_config.tileImg.sw,
            this.page_config.tileImg.ne
          );
          groundOverlayList.push(overlay);
        } else {
          for (let i of this.virtualStations) {
            var tile_info = group_map_tile.find(x => {
              return x.sn === i.sn;
            });
            if (tile_info) {
              var sw = new BMap.Point(tile_info.sw[0], tile_info.sw[1]);
              var ne = new BMap.Point(tile_info.ne[0], tile_info.ne[1]);
              var overlay = this.setImg(tile_info.sn + ".png", sw, ne);
              groundOverlayList.push(overlay);
            }
          }
        }
        this.groundOverlayList = groundOverlayList;
      }
    },
    setTileZindex(img_url) {
      let imgs = document.getElementsByTagName("img");
      let groundImg;
      for (var i of imgs) {
        if (i.src.indexOf(img_url) !== -1) {
          groundImg = i;
          break;
        }
      }
      var p = groundImg.parentNode.parentNode;
      p.style.zIndex = 200;
    },
    drawWzpoint() {
      // if (this.time_type !== "real") {
      //   this.map.closeInfoWindow();
      // }
      let zoom = this.map.getZoom();
      if (zoom > 16) {
        this.page_config.showWind &&
          this.windMapLayer &&
          this.windMapLayer.show();
      } else {
        this.page_config.showWind &&
          this.windMapLayer &&
          this.windMapLayer.hide();
      }
      this.img = new Image();
      if (zoom > 16) {
        this.img.src = "images/dir.svg";
      } else {
        this.img.src = "images/dir_little.svg";
      }
      var self = this;
      this.img.onload = function() {
        let draw_data = [];
        let gfDrawData = [];
        let idx = 0;

        let wzSensortype = !self.showGfStation
          ? self.sensortype
          : self.gfSensortype.length == 2
          ? "cod"
          : self.gfSensortype[0];
        // 标站接口返回数据中cod即cod_mn
        let gfSensortype = !self.showGfStation
          ? self.sensortype
          : self.gfSensortype.length == 2
          ? "cod_mn"
          : self.gfSensortype[0] == "temperature"
          ? "water_temperature"
          : self.gfSensortype[0];
        let codmnIntensity = null;
        if (self.gfSensortype.length == 2) {
          codmnIntensity = new colorIntensity.getIntensity({
            dataType: gfSensortype,
            max: self.colorRange[1],
            min: self.colorRange[0],
            colorType: "static"
          });
        }
        for (let i of self.stationData) {
          idx++;
          // if (idx > 20) break;
          let val = i[wzSensortype];
          if (!val) val = -1;

          let name = i.name;

          if (JSON.stringify(self.sampleDevices) !== "{}") {
            name = i.name in self.sampleDevices ? "🥛 " + name : name;
          }
          name = i.sn.length > 9 ? "🔧 " + name : name;

          var p = {
            text: name,
            countText: self.$sensortypeRound(wzSensortype, val),
            count: val,
            info: i,
            station: i,
            geometry: {
              type: "Point",
              coordinates: [i.Lng, i.Lat]
            }
            // fillStyle: "red"
          };

          if (self.page_config.showWind) {
            p.deg = i.wind_direction;
            p.icon = self.img;
          }
          if (val == -1 || val == "--") {
            p.fillStyle = "gray";
            p.count = "--";
            p.countText = "--";
            self.$store.dispatch("getStations");
          }
          draw_data.push(p);
        }

        let gfStationData = self.gfStationData.filter(item =>
          self.gfLevelList.includes(item.station_level)
        );
        for (let i of gfStationData) {
          idx++;
          // if (idx > 20) break;

          let val = i[gfSensortype];
          if (!val) val = -1;

          let name = "★ " + i.station;

          var p = {
            text: name,
            countText: self.$sensortypeRound(gfSensortype, val),
            count: val,
            info: i,
            station: i,
            geometry: {
              type: "Point",
              coordinates: [i.lng, i.lat]
            }
            // fillStyle: "#9A48F5"
          };
          if (self.gfSensortype.length == 2) {
            p.fillStyle =
              codmnIntensity && codmnIntensity.bgcolor.getColor(val);
          }

          if (self.page_config.showWind) {
            p.deg = i.wind_direction;
            p.icon = self.img;
          }
          if (val == -1 || val == "--") {
            p.fillStyle = "gray";
            p.count = "--";
            p.countText = "--";
          }
          gfDrawData.push(p);
        }

        self.changeMapColor();
        self.dataSet.set(draw_data);
        self.gfStantionDataSet.set(gfDrawData);
        self.drawVirtual();
      };
    },
    drawTimeAnimate() {
      let timeData = [];
      let data = [];
      for (let i of this.virtualStations) {
        let child = i.child_stations;
        let child_list = child.split(",");
        let child_info_list = this.stations.filter(x => {
          return child_list.indexOf(x.station_id + "") !== -1;
        });
        for (let c of child_info_list) {
          let toCenter = { lng: i.Lng, lat: i.Lat };
          let fromCenter = { lng: c.Lng, lat: c.Lat };
          data.push({
            from: {
              city: "",
              lnglat: [c.Lng, c.Lat]
            },
            to: {
              city: "",
              lnglat: [i.Lng, i.Lat]
            }
          });
          var curve = mapv.utilCurve.getPoints([fromCenter, toCenter]);

          for (var j = 0; j < curve.length; j++) {
            timeData.push({
              geometry: {
                type: "Point",
                coordinates: curve[j]
              },
              count: 1,
              time: j,
              text: i.title
            });
          }
        }
      }
      var timeDataSet = new mapv.DataSet(timeData);
      // var textDataSet = new mapv.DataSet(timeData);
      var timeOptions = {
        fillStyle: "rgba(255, 250, 250, 0.5)",
        zIndex: 200,
        size: 2.5,
        animation: {
          type: "time",
          stepsRange: {
            start: 0,
            end: 50
          },
          trails: 10,
          duration: 2
        },
        draw: "simple"
      };
      var timeMapvLayer = new mapv.baiduMapLayer(
        this.map,
        timeDataSet,
        timeOptions
      );
      /*  var textMapvLayer = new mapv.baiduMapLayer(
        this.map,
        textDataSet,
        {draw: 'text', font: '14px Arial', fillStyle: 'white', zIndex: 999}
      ); */
      return;
      // this.drawFlash();
      window.data = data;
      var moveLine = new MoveLine(this.map, {
        //marker点半径
        markerRadius: 2,
        //marker点颜色,为空或null则默认取线条颜色
        markerColor: null,
        //线条类型 solid、dashed、dotted
        lineType: "solid",
        //线条宽度
        lineWidth: 1,
        //线条颜色
        colors: [
          "#F9815C",
          "#F8AB60",
          "#EDCC72",
          "#E2F194",
          "#94E08A",
          "#4ECDA5"
        ],
        //移动点半径
        moveRadius: 2,
        //移动点颜色
        fillColor: "#fff",
        //移动点阴影颜色
        shadowColor: "#fff",
        //移动点阴影大小
        shadowBlur: 5,

        data: data
      });

      var options = {
        //移动点半径
        moveRadius: 2,
        //移动点颜色
        fillColor: "#fff",
        //移动点阴影颜色
        shadowColor: "#fff",
        //移动点阴影大小
        shadowBlur: 10
      };
      moveLine.update(options);
    },

    drawFlash(map) {
      var points = [];
      for (let i of this.virtualStations) {
        points.push({
          name: i.name,
          lnglat: [i.Lng, i.Lat],
          color: "#5070FF",
          type: "circle",
          speed: 0.5,
          max: 70
        });
      }
      var flashMarkerLayer = new FlashMarker(map, points);
    },
    openMapWindowStation(map, station) {
      let p = new BMap.Point(station.Lng, station.Lat);
      let zoom = this.map.getZoom();
      if (zoom < 15) {
        zoom = 15;
      }
      this.map.centerAndZoom(p, zoom);
      this.station_dialog_type = "station";
      this.chooseStation = station;
      openStationWindow({
        map: this.map,
        point: p,
        groups: this.authUserInfo.devGroupIds,
        station: station,
        timeType: this.time_type,
        dataType: this.sensortype,
        showChilds: this.showChilds,
        valueTime: this.timeRange,
        calied_type: 1
      });
      // this.showBigStationDialog = true
    },
    drawWzpoint2() {
      this.clearMarkers(this.markers);
      let markers = [];
      for (let d of this.stationData) {
        let val = d[this.sensortype];
        let m = addMarker({
          map: this.map,
          info: d,
          title: d.name,
          showTitle: true,
          value: val,
          drawCircle: false,
          circleR: 0,
          icon: d.icon ? d.icon : "▲",
          intensity: this.intensity,
          bgcolorDefault: null,
          fgcolorDefault: null,
          coord: "bd09",
          showValue: true,
          clickCallBack: this.openMapWindowStation
        });
        markers.push(m);
      }
      this.markers = markers;
      this.drawVirtual();
      return markers;
    },
    clearMarkers(markers) {
      if (markers) {
        for (let i of markers) {
          this.map.removeOverlay(i);
        }
      }
    },
    drawVirtual(data) {
      this.clearMarkers(this.markersVirtual);
      let markers = [];
      const drawData = data ? data : this.virtualStationData;
      for (let d of drawData) {
        let val = d[this.sensortype];
        let m = addMarker({
          map: this.map,
          info: d,
          title: d.name,
          showTitle: true,
          value: val,
          drawCircle: false,
          circleR: 0,
          icon: d.icon ? d.icon : "★",
          intensity: this.intensity,
          bgcolorDefault: null,
          fgcolorDefault: null,
          coord: "bd09",
          showValue: true
          // clickCallBack: openPoints
        });
        let t = addTextMarker({
          map: this.map,
          text: d.name,
          info: d,
          coord: "bd09"
        });
        markers.push(m);
        markers.push(t);
      }
      this.markersVirtual = markers;
      return markers;
    }
    /* drawInfo(data) {
      if(this.markers.length > 0) {
        this.markers.forEach(item => {
          this.map.removeOverlay(item)
        })
      }
      for(let item of data) {
        const point = new BMap.Point(item.Lng, item.Lat)
        const infoMarker = new ComplexCustomOverlay(map, point, item);
        this.map.addOverlay(infoMarker);
        this.markers.push(infoMarker);
      }
    } */
  }
};
</script>
